const DiscountDescription = {
  description: 'Title',
  key: 'Key',
  sequential: 'When checked, the "percent off" considers already discounted amounts (by former discounts)',
};

export default DiscountDescription;
